import { TabsItem } from '@protoss/ui';
import * as React from 'react';

interface DraggableTabBarProps {
  items: readonly TabsItem[];
  value?: string;
  onValueChange?: (value: string) => void;
  onTabDragStart?: (tab: string) => void;
  ariaLabel: string;
  variant?: 'subnav' | 'plain';
  className?: string;
}

export function DraggableTabBar({
  items,
  value,
  onValueChange,
  onTabDragStart,
  ariaLabel,
}: DraggableTabBarProps) {
  const handleDragStart = (e: React.DragEvent<HTMLButtonElement>, tabValue: string) => {
    e.dataTransfer.effectAllowed = 'copy';
    e.dataTransfer.setData('text/plain', tabValue);
    onTabDragStart?.(tabValue);
  };

  return (
    <div role="tablist" aria-label={ariaLabel} className="deal-draggable-tab-bar">
      {items.map((item) => (
        <button
          key={item.value}
          type="button"
          draggable={item.value !== value}
          onDragStart={(e) => {
            if (item.value !== value) {
              handleDragStart(e, item.value);
            }
          }}
          role="tab"
          aria-selected={item.value === value}
          aria-disabled={item.disabled}
          tabIndex={item.value === value ? 0 : -1}
          onClick={() => !item.disabled && onValueChange?.(item.value)}
          disabled={item.disabled}
          className="deal-draggable-tab-bar__tab"
        >
          {item.icon ? <span className="tabs__icon">{item.icon}</span> : null}
          <span className="tabs__label">{item.label}</span>
        </button>
      ))}
    </div>
  );
}
